import React, { useState } from "react";
import OrderFormModal from "./oderForm.js";
import thongTinSanPham from "../assets/thongtinsanpham.png";
import loa from "../assets/Loa.png";
import imageLoa from "../assets/imageMobileLoa.png";
import iconButton from "../assets/Vector.png";
import title from "../assets/LOA BLUETOOTH RR88 CAO CẤP.png";
import loa1 from "../assets/loa1.png";
import loa2 from "../assets/loa2.png";
import loa3 from "../assets/loa3.png";
import loa4 from "../assets/loa4.png";

const GiftDetailModal3 = ({ isOpen, closeModal }) => {
  const [isOderFormModalOpen, setIsOderFormModalOpen] = useState(false);
  const closeOderFormModal = () => setIsOderFormModalOpen(false);
  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center">
        <div className="relative bg-white p-8 rounded-lg w-[950px] h-[870px] max-w-[1400px] max-h-[800px] overflow-auto shadow-lg  md:block hidden">
          <h3 className="font-bold pb-3 border-b-2 mb-5">THÔNG TIN SẢN PHẨM</h3>
          <div className="flex space-x-4">
            <div className="text-black p-1 w-3/5 flex gap-2">
              <img
                src={loa}
                alt="chitietqua"
                className="w-[409px] h-auto object-cover rounded-lg mb-4 "
              />
              <div className="flex flex-col gap-2">
                <img src={loa1} alt="" />
                <img src={loa2} alt="" />
                <img src={loa3} alt="" />
                <img src={loa4} alt="" />
              </div>
            </div>
            <div className="relative p-1 w-2/5">
              <img src={title} alt="" />
              <div className="flex flex-col space-y-2"></div>
              <button
                className="relative mx-auto bg-blue-500 text-white px-10 py-2 rounded-l-full m-10 rounded-r-full hover:bg-blue-600 flex gap-3"
                onClick={() => setIsOderFormModalOpen(true)}
                style={{
                  backgroundImage: `url(/images/bgButton.png)`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <img src={iconButton} alt="" />
                ĐĂNG KÝ NHẬN
              </button>
            </div>
          </div>
          <div className="text-[13px] font-semibold">
            Nắm bắt được nhu cầu sử dụng loa kéo giải trí văn nghệ rất lớn của
            các thành viên trong dịp lễ lộc, liên hoan, gặp gỡ bạn bè, đồng
            nghiệp... do đó RR88 triển khai chương trình tặng loa kéo trị giá 10
            triệu đồng cho các thành viên VIP - Tất cả thành viên RR88 trong
            tháng chỉ cần hoàn thành 500,000 điểm cược hợp lệ đều có thể liên hệ
            để nhận ngay 1 phần quà là 1 Loa Kéo Bluetooth chất lượng cao BKQ-12
            trị giá 10 triệu đồng. Hãy nhanh tay tham gia ngay tại RR88 để nhận
            ưu đãi cực HOT.
            <br /> <br />
            Loa Bluetooth là một loại loa không dây có khả năng kết nối với các
            thiết bị khác thông qua công nghệ Bluetooth. Thông qua kết nối không
            dây này, người dùng có thể phát nhạc từ điện thoại di động, máy tính
            bảng, máy tính, hoặc bất kỳ thiết bị khác hỗ trợ Bluetooth.
            <br />
            <br />
            Loa Bluetooth thường được thiết kế để di động và dễ dàng mang theo
            để sử dụng ở nhiều vị trí khác nhau, từ phòng khách đến ngoài trời.
            Điều này làm cho chúng trở thành một phụ kiện âm thanh phổ biến cho
            việc nghe nhạc trong các cuộc tiệc tùng hoặc hoạt động ngoài trời.
            <br />
            <br />
          </div>
          <button
            onClick={closeModal}
            className="absolute top-4 right-4 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
          >
            ✕
          </button>
        </div>
        {/* mobile */}
        <div className="relative bg-[#EFF6FF]  p-3 rounded-lg w-[400px] h-[91%] top-[33px] max-w-[1400px]  overflow-auto shadow-lg md:hidden block responsive_mobile">
          <h3 className="font-bold pb-3 border-b-2">THÔNG TIN SẢN PHẨM</h3>

          <div className="w-full mx-auto  bg-gray-100">
            <div>
              <div className="text-black p-1 w-full ">
                <img src={title} alt="" className="mb-5 mt-2 w-[250px]" />
                <div className="text-black p-1 flex gap-2">
                  <img
                    src={loa}
                    alt="chitietqua"
                    className=" h-auto w-[80%] object-cover rounded-lg mb-4 "
                  />
                  <div className="flex flex-col gap-2">
                    <img src={loa1} alt="" />
                    <img src={loa2} alt="" />
                    <img src={loa3} alt="" />
                    <img src={loa4} alt="" />
                  </div>
                </div>
                <div>
                  <button
                    className=" mx-auto bg-blue-500 text-white px-10 py-2 mb-3 rounded-l-full  rounded-r-full hover:bg-blue-600 flex gap-3"
                    onClick={() => setIsOderFormModalOpen(true)}
                    style={{
                      backgroundImage: `url(/images/bgButton.png)`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <img src={iconButton} alt="" />
                    ĐĂNG KÝ NHẬN
                  </button>
                </div>
                <div className="text-[12px]">
                  Nắm bắt được nhu cầu sử dụng loa kéo giải trí văn nghệ rất lớn
                  của các thành viên trong dịp lễ lộc, liên hoan, gặp gỡ bạn bè,
                  đồng nghiệp... do đó RR88 triển khai chương trình tặng loa kéo
                  trị giá 10 triệu đồng cho các thành viên VIP - Tất cả thành
                  viên RR88 trong tháng chỉ cần hoàn thành 500,000 điểm cược hợp
                  lệ đều có thể liên hệ để nhận ngay 1 phần quà là 1 Loa Kéo
                  Bluetooth chất lượng cao BKQ-12 trị giá 10 triệu đồng. Hãy
                  nhanh tay tham gia ngay tại RR88 để nhận ưu đãi cực HOT.
                  <br /> <br />
                  Loa Bluetooth là một loại loa không dây có khả năng kết nối
                  với các thiết bị khác thông qua công nghệ Bluetooth. Thông qua
                  kết nối không dây này, người dùng có thể phát nhạc từ điện
                  thoại di động, máy tính bảng, máy tính, hoặc bất kỳ thiết bị
                  khác hỗ trợ Bluetooth.
                  <br /> <br />
                  Loa Bluetooth thường được thiết kế để di động và dễ dàng mang
                  theo để sử dụng ở nhiều vị trí khác nhau, từ phòng khách đến
                  ngoài trời. Điều này làm cho chúng trở thành một phụ kiện âm
                  thanh phổ biến cho việc nghe nhạc trong các cuộc tiệc tùng
                  hoặc hoạt động ngoài trời.
                  <br /> <br />
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={closeModal}
            className="absolute right-[8px] top-3 text-black bg-gray-200 rounded-full p-2 hover:bg-gray-300"
          >
            ✕
          </button>
        </div>
      </div>
      <OrderFormModal
        isOpen={isOderFormModalOpen}
        closeModal={closeOderFormModal}
        gender=""
        size=""
        type={3}
        checkPoint={500000}
      />
    </>
  );
};
export default GiftDetailModal3;
